import Link from "next/link";
import UpcomingEventsCard from "./UpcomingEventsCard/UpcomingEventsCard";

export default function FeaturedEventDetails({ allEvents }) {
  const currentDate = new Date();

  const upcomingEvents = allEvents?.filter(
    (event) => new Date(event.dateString) > currentDate
  );

  return (
    <>
      {upcomingEvents?.slice(0, 1).map((item) => (
        <Link key={item._id} href={`/events/eventDetails/${item?._id}`}>
          <UpcomingEventsCard item={item} />
        </Link>
      ))}
    </>
  );
}
